import { Alert, Button, Checkbox, Dialog, FormControlLabel, FormGroup, Grid2, InputLabel, MenuItem, Select, Snackbar, TextField } from "@mui/material";
import { Box, Fab } from "@mui/material";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import { useEffect, useState } from "react";
import axios from "axios";
import imageCompression from "browser-image-compression";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useFetcher } from "react-router-dom";

function AdminEquipe() {
    const [equipe, setEquipe] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        cro: "",
        cro_uf: "",
        foto: "",
        titulo: "",
    });
    const [image, setImage] = useState(null);
    const [showAddForm, setShowAddForm] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [successText, setSuccessText] = useState('');
    const [error, setError] = useState(false);
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false)

    const uf = [
        'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO',
    ]

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
      
        try {
          const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1280,
            useWebWorker: true,
          };
      
          let compressedFile = file;
      
          if (file.size / 1024 / 1024 > 1) {
            compressedFile = await imageCompression(file, options);
          }
      
          const previewUrl = URL.createObjectURL(compressedFile);
          
          setFormData((prev) => ({
            ...prev,
            fotoFile: compressedFile,   // arquivo final (pronto pra enviar)
            fotoPreview: previewUrl,    // preview
          }));
        } catch (error) {
          console.error("Erro ao comprimir a imagem:", error);
        }
    };
    const handleClickDialog = () => {
        setOpenDialog(true);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setError(false);
        setOpenDialog(false);
        setOpen(false);
    };
    const fetchEquipe = async () => {
        try {
            const response = await axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-equipe`);
            
            setEquipe(response.data)
            
        } catch (error) {
            console.error("Erro na requisição:", error);
        }
    };

    useEffect(() => {
        fetchEquipe();
    }, []);

    const handleSelectCard = (equipe) => {
        if (showAddForm) {
            setShowAddForm(false)
        }
        if (selectedCard?.id === equipe.id) {
            handleCancel();
        } else {
            axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-equipe?name=${equipe.name}`)
            .then((response) => {
                const data = response.data;
                if (data) {
                    setSelectedCard(equipe);
                    setFormData({
                        id: data.id || "",
                        name: data.name || "",
                        cro: data.cro || "",
                        cro_uf: data.cro_uf || "",
                        foto: data.foto || "",
                        titulo: data.titulo || "",
                        fotoFile:null,
                        fotoPreview:"",
                    });
                };
            });
        };
    };

    const handleCancel = () => {
        setSelectedCard(null);
        setFormData({id:"", name: "", cro: "", cro_uf: "", foto: "", titulo: "" });
        setImage(null);
        if(showAddForm) {
          setShowAddForm(false);
        }
    };

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSave = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("name", formData.name);
            formDataToSend.append("cro", formData.cro);
            formDataToSend.append("cro_uf", formData.cro_uf);
            formDataToSend.append("titulo", formData.titulo);

            if (formData.fotoFile) {
            formDataToSend.append("foto", formData.fotoFile); 
            }
        
            await axios.post(
            `https://api.sigmasystems.com.br/api/odontoluzzi/edit-equipe/${formData.id}`,
            formDataToSend,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
            );
        
            setOpen(true);
            setSuccessText("Integrante Alterado!");
            handleCancel();
            await fetchEquipe();
        } catch (error) {
            setError(true);
            setErrorText("Erro ao alterar Integrante!");
            console.error("Erro ao salvar Integrante:", error);
        }
    };

    const handleOpenAdd = () => {
        setSelectedCard(null);
        setShowAddForm(true);
        setFormData([])
    }

    const handleExcluir = async () => {
        try {
          const id = formData.id;
          await axios.post(
            'https://api.sigmasystems.com.br/api/odontoluzzi/remove-equipe',
            {id:id},
          );
          setOpen(true);
          setOpenDialog(false);
          setSelectedCard(null);
          fetchEquipe();
          setSuccessText('Integrante excluído!')
        } catch (error) {
          setError(true);
          setErrorText('Erro ao excluir Integrante!')
        }
    }

    const handleAdd = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("name", formData.name);
            formDataToSend.append("cro", formData.cro);
            formDataToSend.append("cro_uf", formData.cro_uf);
            formDataToSend.append("titulo", formData.titulo);

            if (formData.fotoFile) {
            formDataToSend.append("foto", formData.fotoFile); // campo precisa ter o mesmo nome usado no multer
            }

            if(!formData.name || !formData.titulo || !formData.cro || !formData.cro_uf) {
                setError(true);
                setErrorText('Verifique os campos!');
                return error;
            }
            await axios.post('https://api.sigmasystems.com.br/api/odontoluzzi/equipe-register', formDataToSend,
                {
                    headers: {
                        "Content-Type":"multipart/form-data",
                    }
                }
            );
            setOpen(true);
            setSuccessText('Integrante Cadastrado!');
            await fetchEquipe();
            handleCancel();
        } catch (error) {
            setError(true);
            setErrorText('Erro ao cadastrar Integrante!');
            console.error("Erro ao salvar integrante:", error);
        }
    }
    

    return(
    <div className="container">
        <div className="body" style={{ justifyItems: "center", width: "100%" }}>
            <div className="adminMenuContainer">
                <div className="adminTitle">Especialidades</div>
                <div
                    className="adminMenuContent"
                    style={{
                    maxWidth: "1280px",
                    height: "fit-content",
                    maxHeight:'700px',
                    borderRadius: "0px 0px 10px 10px",
                    }}
                >
                    <Grid2 container spacing={2}>
                        <Grid2 item>
                            <Button
                            onClick={handleOpenAdd}
                            sx={{
                                color: "#fff",
                                height: 40,
                                width: 162,
                                borderRadius: "5px",
                                fontSize: "18px",
                                backgroundColor: "#B08E44",
                                textTransform: "none",
                                "&:hover": { color: "#fff", backgroundColor: "#041819" },
                            }}
                            >
                            + ADICIONAR
                            </Button>
                        </Grid2>
                        <Grid2 item>
                            <Button
                            disabled={!selectedCard}
                            onClick={handleClickDialog}
                            sx={{
                                color: "#B08E44",
                                height: 40,
                                width: 162,
                                borderRadius: "5px",
                                fontSize: "18px",
                                backgroundColor: "none",
                                border: selectedCard ? "solid 2px #B08E44" : 'solid 2px #cfcfcf',
                                "&:hover": { color: "#fff", backgroundColor: "#041819" },
                            }}
                            >
                            EXCLUIR
                            </Button>
                        </Grid2>
                    </Grid2>
                    <div className="adminSubTitle">Lista de Integrantes</div>
                    <Grid2 container spacing={2}>
                    {equipe.map((equipe) => (
                        <Grid2 item key={equipe.id}>
                        <Button
                            sx={{
                            color:
                                selectedCard?.id === equipe.id
                                ? "#fff"
                                : "#B08E44",
                            border:
                                selectedCard?.id === equipe.id
                                ? "none"
                                : "2px solid #B08E44",
                            backgroundColor:
                                selectedCard?.id === equipe.id ? "#B08E44" : "#fff",
                            "&:hover": {
                                backgroundColor: "#041819",
                                color: "#fff",
                            },
                            }}
                            variant={
                                selectedCard?.id === equipe.id
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => handleSelectCard(equipe)}
                        >
                            {equipe.name}
                        </Button>
                        </Grid2>
                    ))}
                    </Grid2>
                    {showAddForm && (
                    <div>
                        <div className="adminSubTitle">Imagem</div>
                        <Grid2 container spacing={2}>
                        <Grid2 item>
                            <img
                            src={
                                formData.fotoPreview
                                ? formData.fotoPreview
                                : "https://odontoluzzi.com.br/images/padrao/padraoEquipe.png"
                            }
                            alt="Nova Imagem"
                            style={{
                                width: "100%",
                                maxWidth:'400px',
                                height:'110px',
                                borderRadius: "8px",
                                objectFit:'cover'
                            }}
                            />
                        </Grid2>
                        <Grid2 item>
                            <label className="btnUpload">
                            <input
                                style={{ display: "none" }}
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                            Escolher<br/>Foto
                            </label>
                        </Grid2>
                        </Grid2>

                        <div className="adminSubTitle">Nome</div>
                        <TextField
                        fullWidth
                        variant="outlined"
                        value={formData.name}
                        onChange={(e) => handleChange("name", e.target.value)}
                        />

                        <div className="adminSubTitle">Título</div>
                        <TextField
                        fullWidth
                        multiline
                        variant="outlined"
                        value={formData.titulo}
                        onChange={(e) => handleChange("titulo", e.target.value)}
                        />

<div className="adminSubTitle">CRO</div>
                        <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid2 item>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    MenuProps={{
                                        style: {
                                            maxHeight:250,
                                            // overflowY:'auto'
                                        }
                                    }}
                                    value={formData.cro_uf}
                                    onChange={(e) => handleChange("cro_uf", e.target.value)}
                                >
                                    {uf.map((uf) => (
                                        <MenuItem key={uf} value={uf}>{uf}</MenuItem>
                                    ))}
                                    
                                </Select>
                            </Grid2>
                            <Grid2 item>
                                <TextField
                                fullWidth
                                multiline
                                variant="outlined"
                                value={formData.cro}
                                onChange={(e) => handleChange("cro", e.target.value)} />
                            </Grid2>
                        </Grid2>

                        <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid2 item>
                            <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#B08E44",
                                "&:hover": { backgroundColor: "#041819" },
                            }}
                            onClick={handleAdd}
                            >
                            Finalizar
                            </Button>
                        </Grid2>
                        <Grid2 item>
                            <Button
                            variant="outlined"
                            sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                            onClick={handleCancel}
                            >
                            Cancelar
                            </Button>
                        </Grid2>
                        </Grid2>

                        
                    </div>)}
                    {selectedCard && (
                    <div>
                        <div className="adminSubTitle">Imagem</div>
                        <Grid2 container spacing={2}>
                        <Grid2 item>
                            <img
                            src={
                                formData.fotoPreview
                                ? formData.fotoPreview
                                : formData.foto ? `https://api.sigmasystems.com.br/api/odontoluzzi/uploads/equipe/${formData.foto}`
                                : "https://odontoluzzi.com.br/images/padrao/padraoServico.png"
                            }
                            alt={formData.foto}
                            style={{
                                width: "100%",
                                maxWidth:'110px',
                                height:'110px',
                                borderRadius: "8px",
                                objectFit:'cover'
                            }}
                            />
                        </Grid2>
                        <Grid2 item>
                            <label className="btnUpload">
                            <input
                                style={{ display: "none" }}
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                            Trocar Foto
                            </label>
                        </Grid2>
                        </Grid2>

                        <div className="adminSubTitle">Nome</div>
                        <TextField
                        fullWidth
                        variant="outlined"
                        value={formData.name}
                        onChange={(e) => handleChange("name", e.target.value)}
                        />

                        <div className="adminSubTitle">Título</div>
                        <TextField
                        fullWidth
                        multiline
                        variant="outlined"
                        value={formData.titulo}
                        onChange={(e) => handleChange("titulo", e.target.value)}
                        />

                        <div className="adminSubTitle">CRO</div>
                        <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid2 item>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    MenuProps={{
                                        style: {
                                            maxHeight:250,
                                            // overflowY:'auto'
                                        }
                                    }}
                                    value={formData.cro_uf}
                                    onChange={(e) => handleChange("cro_uf", e.target.value)}
                                >
                                    {uf.map((uf) => (
                                        <MenuItem key={uf} value={uf}>{uf}</MenuItem>
                                    ))}
                                    
                                </Select>
                            </Grid2>
                            <Grid2 item>
                                <TextField
                                fullWidth
                                multiline
                                variant="outlined"
                                value={formData.cro}
                                onChange={(e) => handleChange("cro", e.target.value)} />
                            </Grid2>
                        </Grid2>
                        
                        

                        <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid2 item>
                            <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#B08E44",
                                "&:hover": { backgroundColor: "#041819" },
                            }}
                            onClick={handleSave}
                            >
                            Finalizar
                            </Button>
                        </Grid2>
                        <Grid2 item>
                            <Button
                            variant="outlined"
                            sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                            onClick={handleCancel}
                            >
                            Cancelar
                            </Button>
                        </Grid2>
                        </Grid2>
                    </div>
                    )}
                </div>
            </div>
            <Box
            sx={{
              "& > :not(style)": { m: 1 },
              position: "absolute",
              bottom: 16,
              right: 16,
            }}
          >
            <Fab
              onClick={() => window.history.back()}
              variant="extended"
              sx={{
                backgroundColor: "#B08E44",
                color: "#fff",
                "&:hover": { backgroundColor: "#041819" },
              }}
            >
              <ReplyRoundedIcon sx={{ mr: 1 }} /> Voltar
            </Fab>
          </Box>
        </div>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
            <Alert
            onClose={handleClose}
            severity="success"
            variant="filled"
            sx={{ width: '100%' }}
            >
            {successText}
            </Alert>
        </Snackbar>
        <Snackbar open={error} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
            <Alert
            onClose={handleClose}
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
            >
            {errorText}
            </Alert>
        </Snackbar>
        <Dialog
            open={openDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Tem certeza que deseja excluir da equipe?"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                "{formData.name}"
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button onClick={handleExcluir} autoFocus>
                EXCLUIR
            </Button>
            </DialogActions>
        </Dialog>
    </div>
    )
}
export default AdminEquipe;